/**
 * @format
 */
import {
  addVisibleListId,
  removeVisibleListId,
} from '../../../helpers/listVisibility';
import { UPDATE_LIST_VISIBILITY } from '../actions';

// This will go and update the lists redux states isVisible property for the list_id of the workspace_id
export default (workspace_id, list_id, isVisible) => {
  return dispatch => {
    isVisible
      ? addVisibleListId(workspace_id, list_id)
      : removeVisibleListId(workspace_id, list_id);
    dispatch({
      type: UPDATE_LIST_VISIBILITY,
      payload: { workspace_id, list_id, isVisible },
    });
  };
};
